import * as STD from '@emersya/mpa-std';
import {Modal, Text} from '@emersya/mpa-components';
import * as CM from '@emersya/mpa-components-manager';

export interface IOrderConfirmedModalConfiguration extends Modal.Configuration {
};

export class OrderConfirmedModal extends Modal.Component<
	{
		readonly replayURL: string | null;
	},
	null
> {

	protected override canBeClosed(): boolean {
		return true;
	};

	protected override async onOpen() {
		STD.translationsManager.update(this.component_DOM);
		const textWithReplayLink = <Text.Component>this.component_find('@:content.textWithReplayLink');
		const textWithoutReplayLink = <Text.Component>this.component_find('@:content.textWithoutReplayLink');
		if (this.data?.replayURL) {
			await textWithReplayLink.component_enable();
			await textWithoutReplayLink.component_disable();
			textWithReplayLink.component_DOM.textContent = textWithReplayLink.component_DOM.textContent.replace('$$$', this.data?.replayURL ? this.data?.replayURL : '');
		} else {
			await textWithReplayLink.component_disable();
			await textWithoutReplayLink.component_enable();
		}
	};

	protected override onClose() {
	};

	protected override async onValidate() {
		return await Promise.resolve(null);
	};

	override async component_initialize() {
		await super.component_initialize();
	};

	override async component_start(startEvent: STD.events.Event<any, CM.Component<any, any>>) {
		await super.component_start(startEvent);
		STD.translationsManager.update(this.component_DOM);
	};

	constructor(
		descriptor: ConstructorParameters<typeof CM.Component>[0],
		configuration: IOrderConfirmedModalConfiguration
	) {
		super(descriptor, configuration);
		this.component_DOM = <HTMLDivElement>STD.DOM.factory({
			tag: 'div'
		});
	};
};
export namespace NS {
	export const Component = OrderConfirmedModal;
	export type Component = OrderConfirmedModal;
	export type Configuration = IOrderConfirmedModalConfiguration;
}
import manifestXMLSource from './orderconfirmed.xml';
import './orderConfirmed.scss';

CM.Manager.declare({
	id: 'modal-order-confirmed',
	type: OrderConfirmedModal,
	manifest: manifestXMLSource
});
